<template>
  <v-card elevation="0">
    <v-tabs
        v-model="tab"
        background-color="transparent"
        color="#80CBC4"
        grow
    >
        <v-tab
            v-for="item in tabitems"
            :key="item"
        >
            <v-icon>{{ item.icon }}</v-icon>&nbsp;{{ item.text }}
        </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card elevation="0">
            <v-card-text>
                <UploadTimetable v-if="tab == 0" />
            </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card elevation="0">
            <v-card-text>
                <CustomTimetable />
            </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <iframe name="hiddenFrame" hidden></iframe>
  </v-card>
</template>
<script>
import UploadTimetable from "./UploadTimetable.vue"
import CustomTimetable from "./CustomTimetable.vue"
export default {
    components: {
        UploadTimetable,
        CustomTimetable
    },
    data(){
        return {
            tab: 0,
            tabitems: [
                {"text": 'Upload Timetable', "icon": "mdi-timetable"},
                {"text": 'Custom Timetable', "icon": "mdi-table-cog"}
            ]
        }
    }
}
</script>